'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('es6-promise/auto');

require('./event');

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var _aes = require('crypto-js/aes');

var _aes2 = _interopRequireDefault(_aes);

var _encBase = require('crypto-js/enc-base64');

var _encBase2 = _interopRequireDefault(_encBase);

require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 2.3.2
var request;

request = require('superagent');

window.BootPay = {
  VISIT_TIMEOUT: 86400000, // 재 방문 시간에 대한 interval
  SK_TIMEOUT: 1800000, // 30분
  applicationId: void 0,
  version: '2.0.17',
  mode: 'production',
  backgroundId: 'bootpay-background-window',
  windowId: 'bootpay-payment-window',
  iframeId: 'bootpay-payment-iframe',
  closeId: 'close-button-window',
  ieMinVersion: 9,
  deviceType: 1,
  ableDeviceTypes: {
    JS: 1,
    ANDROID: 2,
    IOS: 3
  },
  methods: {},
  params: {},
  option: {},
  phoneRegex: /^\d{2,3}\d{3,4}\d{4}$/,
  dateFormat: /(\d{4})-(\d{2})-(\d{2})/,
  zeroPaymentMethod: ['bankalarm', 'auth', 'card_rebill'],
  urls: require('../package.json').urls,
  tk: void 0,
  restUrl: function restUrl() {
    return this.urls.restUrl[this.mode];
  },
  clientUrl: function clientUrl() {
    return this.urls.clientUrl[this.mode];
  },
  analyticsUrl: function analyticsUrl() {
    return this.urls.analyticsUrl[this.mode];
  },
  initialize: function initialize() {
    var logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    this.setLogLevel(logLevel);
    this.setReadyUUID();
    return this.setReadySessionKey();
  },
  // meta tag에서 application id를 찾는다.
  setApplicationId: function setApplicationId() {
    var applicationId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;

    var metaTag;
    if (applicationId != null) {
      return this.applicationId = applicationId;
    } else {
      metaTag = document.querySelector('meta[name="bootpay-application-id"]');
      if (metaTag != null) {
        return this.applicationId = metaTag.getAttribute('content');
      } else {
        return alert('<meta name="bootpay-application-id" content="[Application ID를 입력]" /> 다음과 같이 <head>안에 넣어주세요');
      }
    }
  },
  //  로그 레벨을 설정한다.
  setLogLevel: function setLogLevel() {
    var logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return _logger2.default.setLogLevel(logLevel);
  },
  setMode: function setMode(mode) {
    return this.mode = mode;
  },
  //----------------------------------------------------------
  // UUID가 없을 경우 바로 LocalStorage에 저장한다.
  // Comment by Gosomi
  // Date: 2018-04-29
  //----------------------------------------------------------
  setReadyUUID: function setReadyUUID() {
    var ref;
    if (!((ref = this.getData('uuid')) != null ? ref.length : void 0)) {
      return this.setData('uuid', this.generateUUID());
    }
  },
  //----------------------------------------------------------
  // Local Storage에서 데이터를 저장한다.
  // Comment by Gosomi
  // Date: 2018-04-28
  //----------------------------------------------------------
  setData: function setData(key, value) {
    return window.localStorage.setItem(key, value);
  },
  //----------------------------------------------------------
  // Local Storage에서 데이터를 가져온다.
  // Comment by Gosomi
  // Date: 2018-04-28
  //----------------------------------------------------------
  getData: function getData(key) {
    return window.localStorage.getItem(key);
  },
  // device Type을 설정한다. 없을 경우 false를 리턴, 있는 경우 true를 리턴
  setDevice: function setDevice(deviceType) {
    if (this.ableDeviceTypes[deviceType] != null) {
      this.deviceType = this.ableDeviceTypes[deviceType];
    }
    return this.ableDeviceTypes[deviceType] != null;
  },
  // 기본적인 통계 데이터를 설정한다.
  // Android, iPhone에서 기본적으로 사용하는 코드
  setAnalyticsData: function setAnalyticsData(data) {
    if (data.uuid != null) {
      this.setData('uuid', data.uuid);
    }
    if (data.sk != null) {
      this.setData('sk', data.sk);
    }
    if (data.sk_time != null) {
      this.setData('sk_time', data.sk_time);
    }
    if (data.time != null) {
      return this.setData('time', data.time);
    }
  },
  // 로그인한 유저 정보를 가져온다.
  getUserData: function getUserData() {
    try {
      return JSON.parse(this.getData('user'));
    } catch (error1) {
      return void 0;
    }
  },
  // Javascript로 UUID를 생성한다.
  generateUUID: function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r, v;
      r = Math.random() * 16 | 0;
      v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  },
  // 로그인 했을때 데이터를 저장한다.
  setUserData: function setUserData(data) {
    return this.setData('user', JSON.stringify(data));
  },
  // 세션 키를 발급하는 로직
  setReadySessionKey: function setReadySessionKey() {
    var lastTime, ref, ref1, sessionKeyTime;
    sessionKeyTime = new Date().getTime();
    if ((ref = this.getData('last_time')) != null ? ref.length : void 0) {
      sessionKeyTime = new Date().getTime();
      if ((ref1 = this.getData('last_time')) != null ? ref1.length : void 0) {
        lastTime = parseInt(this.getData('last_time')); // 마지막으로 접근한 시간을 기록한다.
        this.setData('last_time', sessionKeyTime);
        if (isNaN(lastTime) || lastTime + this.SK_TIMEOUT < sessionKeyTime) {
          // 마지막 접속한 시간에 30분이 지나버린 경우 세션을 초기화한다.
          this.setData('sk', this.getData('uuid') + '-' + sessionKeyTime);
          this.setData('sk_time', sessionKeyTime);
          this.setData('time', sessionKeyTime - lastTime);
          return _logger2.default.debug('\uC2DC\uAC04\uC774 \uC9C0\uB098 \uC138\uC158 \uACE0\uC720 \uAC12 \uC815\uBCF4\uB97C \uC0C8\uB85C \uAC31\uC2E0\uD558\uC600\uC2B5\uB2C8\uB2E4. sk: ' + this.getData('sk') + ', time: ' + this.getData('sk_time'));
        } else {
          return _logger2.default.debug('\uC774\uC804 \uC138\uC158\uC744 \uADF8\uB300\uB85C \uC774\uC6A9\uD569\uB2C8\uB2E4. sk: ' + this.getData('sk') + ', time: ' + this.getData('sk_time'));
        }
      }
    } else {
      this.setData('last_time', sessionKeyTime);
      this.setData('sk', this.getData('uuid') + '-' + sessionKeyTime);
      this.setData('sk_time', sessionKeyTime);
      return _logger2.default.debug("처음 접속하여 세션 고유 값을 설정하였습니다.");
    }
  },
  // 로그인 정보를 절차에 따라 초기화한다.
  expireUserData: function expireUserData() {
    var data;
    data = this.getUserData();
    // 데이터가 없거나 접속 한지 하루가 지나면 데이터를 삭제한다.
    if (data != null && data.time + this.VISIT_TIMEOUT < new Date().getTime()) {
      _logger2.default.info("시간이 지나 로그인 유저 정보를 초기화 하였습니다.");
      return this.setData('user', null);
    }
  },
  // 통계 시작
  startTrace: function startTrace() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;

    var ref;
    if (!((ref = this.applicationId) != null ? ref.length : void 0)) {
      this.setApplicationId();
    }
    this.expireUserData();
    return this.sendCommonData(data);
  },
  // 통계용 데이터를 부트페이로 전송
  sendCommonData: function sendCommonData(data) {
    var encryptData, items, ref, ref1, requestData, url, user;
    url = document.URL;
    if (!url || url.search(/g-cdn.bootpay.co.kr/) === -1 && url.search(/bootpay.co.kr/) > -1 && url.search(/app.bootpay.co.kr/) === -1) {
      return;
    }
    user = this.getUserData();
    items = data != null && ((ref = data.items) != null ? ref.length : void 0) ? data.items : [{
      cat1: data != null ? data.cat1 : void 0,
      cat2: data != null ? data.cat2 : void 0,
      cat3: data != null ? data.cat3 : void 0,
      item_img: data != null ? data.item_img : void 0,
      item_name: data != null ? data.item_name : void 0,
      unique: data != null ? data.unique : void 0,
      price: data != null ? data.price : void 0
    }];
    requestData = {
      application_id: this.applicationId,
      uuid: this.getData('uuid'),
      time: this.getData('time'),
      url: data != null && data.url != null ? data.url : document.URL,
      referer: ((ref1 = document.referrer) != null ? ref1.length : void 0) && document.referrer.search(new RegExp(window.location.hostname)) === -1 ? document.referrer : '',
      sk: this.getData('sk'),
      user_id: user != null ? user.id : void 0,
      page_type: data != null ? data.type : void 0,
      items: items
    };
    _logger2.default.debug('\uD65C\uB3D9 \uC815\uBCF4\uB97C \uC11C\uBC84\uB85C \uC804\uC1A1\uD569\uB2C8\uB2E4. data: ' + JSON.stringify(requestData));
    encryptData = _aes2.default.encrypt(JSON.stringify(requestData), requestData.sk);
    return request.post([this.analyticsUrl(), 'call?ver=' + this.version].join('/')).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8').send({
      data: encryptData.ciphertext.toString(_encBase2.default),
      session_key: encryptData.key.toString(_encBase2.default) + '##' + encryptData.iv.toString(_encBase2.default)
    }).then(function (res) {
      if (res.status !== 200 || res.body.status !== 200) {
        return _logger2.default.warn('BOOTPAY MESSAGE: ' + res.body.message + ' - Application ID\uAC00 \uC81C\uB300\uB85C \uB418\uC5C8\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.');
      }
    }).catch(function (err) {
      return _logger2.default.warn('BOOTPAY MESSAGE: ' + err.body.message + ' - Application ID\uAC00 \uC81C\uB300\uB85C \uB418\uC5C8\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.');
    });
  },
  // 로그인 정보를 부트페이 서버로 전송한다.
  startLoginSession: function startLoginSession(data) {
    var e;
    try {
      if (data == null) {
        throw '로그인 데이터를 입력해주세요.';
      }
      if (data.id == null) {
        throw '로그인 하는 아이디를 입력해주세요.';
      }
    } catch (error1) {
      e = error1;
      _logger2.default.error(e);
      alert(e);
      throw e;
    }
    return this.sendLoginData({
      application_id: data.application_id != null ? data.application_id : this.applicationId,
      id: data.id,
      username: data.username,
      birth: data.birth,
      phone: data.phone,
      email: data.email,
      gender: data.gender,
      area: data.area != null ? String(data.area).match(/서울|인천|대구|광주|부산|울산|경기|강원|충청북도|충북|충청남도|충남|전라북도|전북|전라남도|전남|경상북도|경북|경상남도|경남|제주|세종|대전/) : void 0
    });
  },
  // 부트페이 서버로 데이터를 전송한다.
  sendLoginData: function sendLoginData(data) {
    var _this = this;

    var encryptData, ref;
    if (data == null || document.URL == null) {
      return;
    }
    _logger2.default.debug('\uB85C\uADF8\uC778 \uB370\uC774\uD130\uB97C \uC804\uC1A1\uD569\uB2C8\uB2E4. data: ' + JSON.stringify(data));
    data.area = ((ref = data.area) != null ? ref.length : void 0) ? data.area[0] : void 0;
    encryptData = _aes2.default.encrypt(JSON.stringify(data), this.getData('sk'));
    return request.post([this.analyticsUrl(), 'login?ver=' + this.version].join('/')).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8').send({
      data: encryptData.ciphertext.toString(_encBase2.default),
      session_key: encryptData.key.toString(_encBase2.default) + '##' + encryptData.iv.toString(_encBase2.default)
    }).then(function (res) {
      var json;
      if (res.status !== 200 || res.body.status !== 200) {
        return _logger2.default.warn('BOOTPAY MESSAGE: ' + res.body.message + ' - Application ID\uAC00 \uC81C\uB300\uB85C \uB418\uC5C8\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.');
      } else {
        json = res.body.data;
        return _this.setUserData({
          id: json.user_id,
          time: new Date().getTime()
        });
      }
    }).catch(function (err) {
      return _logger2.default.warn('BOOTPAY MESSAGE: ' + err.message + ' - Application ID\uAC00 \uC81C\uB300\uB85C \uB418\uC5C8\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.');
    });
  },
  // 결제 정보를 보내 부트페이에서 결제 정보를 띄울 수 있게 한다.
  request: function request(data) {
    var e, encryptData, html, ref, ref1, ref2, ref3, user;
    this.removePaymentWindow(false);
    try {
      user = this.getUserData();
      if (data.application_id != null) {
        // 결제 효청시 application_id를 입력하면 덮어 씌운다. ( 결제 이후 버그를 줄이기 위한 노력 )
        this.applicationId = data.application_id;
      }
      this.tk = this.generateUUID() + '-' + new Date().getTime();
      this.params = {
        application_id: this.applicationId,
        show_agree_window: data.show_agree_window != null ? parseInt(data.show_agree_window) : 0,
        device_type: this.deviceType,
        method: data.method != null ? data.method : void 0,
        pg: data.pg != null ? data.pg : void 0,
        name: data.name,
        items: ((ref = data.items) != null ? ref.length : void 0) ? data.items : void 0,
        redirect_url: data.redirect_url != null ? data.redirect_url : '',
        phone: ((ref1 = data.phone) != null ? ref1.length : void 0) ? data.phone.replace(/-/g, '') : '',
        uuid: ((ref2 = data.uuid) != null ? ref2.length : void 0) ? data.uuid : this.getData('uuid'),
        order_id: data.order_id != null ? String(data.order_id) : '',
        user_info: data.user_info != null ? data.user_info : void 0,
        sk: this.getData('sk'),
        time: this.getData('time'),
        price: data.price,
        tax_free: data.tax_free != null ? data.tax_free : 0,
        format: data.format != null ? data.format : 'json',
        params: data.params != null ? data.params : void 0,
        user_id: user != null ? user.id : void 0,
        path_url: document.URL,
        extra: data.extra != null ? data.extra : void 0,
        account_expire_at: data.account_expire_at != null ? data.account_expire_at : void 0,
        tk: this.tk
      };
      // 각 함수 호출 callback을 초기화한다.
      this.methods = {};
      if ((ref3 = this.params.items) != null ? ref3.length : void 0) {
        // 아이템 정보의 Validation
        this.integrityItemData();
      }
      if (this.params.method == null || this.params.method === 'auth') {
        // 결제 정보 데이터의 Validation
        this.integrityParams();
      }
      // 데이터를 AES로 암호화한다.
      encryptData = _aes2.default.encrypt(JSON.stringify(this.params), this.params.sk);
      html = '<div id="' + this.windowId + '">\n  <form name="bootpay_form" action="' + [this.restUrl(), 'start', 'js', '?ver=' + this.version].join('/') + '" method="POST">\n    <input type="hidden" name="data" value="' + encryptData.ciphertext.toString(_encBase2.default) + '" />\n    <input type="hidden" name="session_key" value="' + encryptData.key.toString(_encBase2.default) + '##' + encryptData.iv.toString(_encBase2.default) + '" />\n  </form>\n  <form id="bootpay_confirm_form" name="bootpay_confirm_form" action="' + [this.restUrl(), 'confirm'].join('/') + '" method="POST">\n  </form>\n  <div class="bootpay-window" id="bootpay-background-window">' + this.iframeHtml('') + '</div>\n</div>';
      document.body.insertAdjacentHTML('beforeend', html);
      this.start();
    } catch (error1) {
      e = error1;
      this.sendPaymentStepData({
        step: 'start',
        status: -1,
        e: e
      });
      throw e;
    }
    this.sendPaymentStepData({
      step: 'start',
      status: 1
    });
    return this;
  },
  //  결제 요청 정보 Validation
  integrityParams: function integrityParams() {
    var e, price, ref, ref1, ref2, ref3;
    price = parseFloat(this.params.price);
    try {
      if ((isNaN(price) || price < 1000) && this.zeroPaymentMethod.indexOf(this.params.method) === -1) {
        throw '결제할 금액을 설정해주세요. ( 1,000원 이상, 본인인증/정기 결제요청의 경우엔 0원을 입력해주세요. ) [ params: price ]';
      }
      if (!((ref = this.params.name) != null ? ref.length : void 0)) {
        throw '판매할 상품명을 입력해주세요. [ parmas: name ]';
      }
      if (this.blockIEVersion()) {
        throw '익스플로러 8이하 버전에서는 결제가 불가능합니다.';
      }
      if (((ref1 = this.params.phone) != null ? ref1.length : void 0) && !this.phoneRegex.test(this.params.phone)) {
        throw '휴대폰 번호의 자리수와 형식이 맞지 않습니다. [ params : phone ]';
      }
      if (!((ref2 = this.params.order_id) != null ? ref2.length : void 0)) {
        throw '판매하려는 제품 order_id를 지정해주셔야합니다. 다른 결제 정보와 겹치지 않은 유니크한 값으로 정해서 보내주시기 바랍니다. [ params: order_id ]';
      }
      if (((ref3 = this.params.account_expire_at) != null ? ref3.length : void 0) && !this.dateFormat.test(this.params.account_expire_at) && this.params.method === 'vbank') {
        throw '가상계좌 입금 만료일 포멧이 잘못되었습니다. yyyy-mm-dd로 입력해주세요. [ params: account_expire_at ]';
      }
    } catch (error1) {
      e = error1;
      alert(e);
      _logger2.default.error(e);
      throw e;
    }
  },
  // 아이템 정보 Validation
  integrityItemData: function integrityItemData() {
    var e;
    try {
      if (!Array.isArray(this.params.items)) {
        throw '아이템 정보가 배열 형태가 아닙니다.';
      }
      return this.params.items.forEach(function (item, index) {
        var ref, ref1;
        if (!((ref = item.item_name) != null ? ref.length : void 0)) {
          throw '\uD1B5\uACC4\uC5D0 \uD544\uC694\uD55C \uC544\uC774\uD15C \uC774\uB984\uC774 \uC5C6\uC2B5\uB2C8\uB2E4. [key: item_name, index: ' + index + '] ';
        }
        if (item.qty == null) {
          throw '\uD1B5\uACC4\uC5D0 \uD544\uC694\uD55C \uC0C1\uD488 \uD310\uB9E4 \uAC1C\uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. [key: qty, index: ' + index + ']';
        }
        if (isNaN(parseInt(item.qty))) {
          throw '\uC0C1\uD488 \uD310\uB9E4 \uAC1C\uC218\uB97C \uC22B\uC790\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694. [key: qty, index: ' + index + ']';
        }
        if (!((ref1 = item.unique) != null ? ref1.length : void 0)) {
          throw '\uD1B5\uACC4\uB97C \uC704\uD55C \uC0C1\uD488\uC758 \uACE0\uC720\uAC12\uC744 \uB123\uC5B4\uC8FC\uC138\uC694. [key: unique, index: ' + index + ']';
        }
        if (item.price == null) {
          throw '\uD1B5\uACC4\uB97C \uC704\uD574 \uC0C1\uD488\uC758 \uAC1C\uBCC4 \uAE08\uC561\uC744 \uB123\uC5B4\uC8FC\uC138\uC694. [key: price, index: ' + index + ']';
        }
        if (isNaN(parseInt(item.price))) {
          throw '\uC0C1\uD488\uAE08\uC561\uC740 \uC22B\uC790\uB85C\uB9CC \uAC00\uB2A5\uD569\uB2C8\uB2E4. [key: price, index: ' + index + ']';
        }
      });
    } catch (error1) {
      e = error1;
      alert(e);
      _logger2.default.error(e);
      throw e;
    }
  },
  // 결제창을 조립해서 만들고 부트페이로 결제 정보를 보낸다.
  // 보낸 이후에 app.bootpay.co.kr로 데이터를 전송한다.
  start: function start() {
    this.progressMessageShow('결제창을 불러오는 중입니다.');
    this.closeEventBind();
    document.getElementById(this.iframeId).addEventListener('load', this.progressMessageHide);
    document.bootpay_form.target = 'bootpay_inner_iframe';
    document.bootpay_form.submit();
    return this;
  },
  notify: function notify(data) {
    var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;

    var _this2 = this;

    var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
    var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3000;

    var encryptData, ref, ref1, ref2, user;
    this.removePaymentWindow(false);
    user = this.getUserData();
    this.applicationId = data.application_id != null ? data.application_id : this.applicationId;
    this.params = {};
    this.params.device_type = this.deviceType;
    if (data.method != null) {
      this.params.method = data.method;
    }
    this.params.application_id = this.applicationId;
    this.params.name = data.name;
    if (data.item_code != null) {
      this.params.item_code = data.item_code;
    }
    if (data.item_code != null && data.qty != null) {
      this.params.qty = data.qty;
    }
    this.params.user_info = data.user_info;
    this.params.redirect_url = data.redirect_url != null ? data.redirect_url : '';
    this.params.phone = ((ref = data.phone) != null ? ref.length : void 0) ? data.phone.replace(/-/g, '') : '';
    this.params.uuid = ((ref1 = data.uuid) != null ? ref1.length : void 0) ? data.uuid : window.localStorage['uuid'];
    this.params.order_id = data.order_id != null ? String(data.order_id) : void 0;
    this.params.sk = window.localStorage.getItem('sk');
    this.params.time = window.localStorage.getItem('time');
    this.params.price = data.price;
    if (data.format != null) {
      this.params.format = this.option.format;
    }
    this.params.params = data.params;
    this.params.user_id = user != null ? user.id : void 0;
    this.params.bank_account = data.bank_account != null ? data.bank_account : void 0;
    this.params.bank_name = data.bank_name != null ? data.bank_name : void 0;
    this.params.order_unique = data.order_unique != null ? data.order_unique : 0;
    if ((ref2 = this.params.items) != null ? ref2.length : void 0) {
      this.integrityItemData();
    }
    this.params.items = data.items;
    if (this.params.method == null || !this.params.method !== 'auth') {
      this.integrityParams();
    }
    encryptData = _aes2.default.encrypt(JSON.stringify(this.params), this.getData('sk'));
    return request.post([this.restUrl(), 'notify?ver=' + this.version + '&format=json'].join('/')).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8').timeout({
      response: timeout,
      deadline: timeout
    }).send({
      data: encryptData.ciphertext.toString(_encBase2.default),
      session_key: encryptData.key.toString(_encBase2.default) + '##' + encryptData.iv.toString(_encBase2.default)
    }).then(function (res) {
      if (res.status !== 200 || res.body.status !== 200) {
        _logger2.default.error('BOOTPAY MESSAGE: ' + res.body.message + ' - Application ID\uAC00 \uC81C\uB300\uB85C \uB418\uC5C8\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.');
        if (error != null) {
          return error.apply(_this2, ['BOOTPAY MESSAGE: ' + res.body.message + ' - Application ID\uAC00 \uC81C\uB300\uB85C \uB418\uC5C8\uB294\uC9C0 \uD655\uC778\uD574\uC8FC\uC138\uC694.', res.body]);
        }
      } else {
        if (success != null) {
          return success.apply(_this2, [res.body.data]);
        }
      }
    }).catch(function (err) {
      if (error != null) {
        return error.apply(_this2, ['\uC11C\uBC84 \uC624\uB958\uB85C \uC778\uD574 \uACB0\uC81C\uAC00 \uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. ' + err.message]);
      }
    });
  },
  // 창이 닫혔을 때 이벤트 처리
  closeEventBind: function closeEventBind() {
    var _this3 = this;

    window.off('message.BootpayGlobalEvent');
    return window.on('message.BootpayGlobalEvent', function (e) {
      var backgroundSelector, closeSelector, data, iframeSelector;
      try {
        data = {};
        if (e.data != null && typeof e.data === 'string') {
          data = JSON.parse(e.data);
        }
      } catch (error1) {
        e = error1;
        _logger2.default.error('data: ' + e.data + ', ' + e.message + ' json parse error');
        return;
      }
      switch (data.action) {
        case 'BootpayCancel':
          _this3.progressMessageShow('결제를 취소중입니다.');
          try {
            if (_this3.methods.cancel != null) {
              _this3.methods.cancel.call(_this3, data);
            }
          } catch (error1) {
            e = error1;
            _this3.sendPaymentStepData({
              step: 'cancel',
              status: -1,
              e: e
            });
            throw e;
          }
          _this3.sendPaymentStepData({
            step: 'cancel',
            status: 1
          });
          return _this3.removePaymentWindow();
        case 'BootpayBankReady':
          try {
            if (_this3.methods.ready != null) {
              _this3.methods.ready.call(_this3, data);
            }
          } catch (error1) {
            e = error1;
            _this3.sendPaymentStepData({
              step: 'ready',
              status: -1,
              e: e
            });
            throw e;
          }
          return _this3.sendPaymentStepData({
            step: 'ready',
            status: 1
          });
        case 'BootpayConfirm':
          _this3.progressMessageShow('결제를 승인중입니다.');
          try {
            if (_this3.methods.confirm == null) {
              _this3.transactionConfirm(data);
            } else {
              _this3.methods.confirm.call(_this3, data);
            }
          } catch (error1) {
            e = error1;
            _this3.sendPaymentStepData({
              step: 'confirm',
              status: -1,
              e: e
            });
            throw e;
          }
          return _this3.sendPaymentStepData({
            step: 'confirm',
            status: 1
          });
        case 'BootpayResize':
          iframeSelector = document.getElementById(_this3.iframeId);
          backgroundSelector = document.getElementById(_this3.backgroundId);
          closeSelector = document.getElementById(_this3.closeId);
          if (data.reset) {
            iframeSelector.removeAttribute('style');
            backgroundSelector.removeAttribute('style');
            closeSelector.removeAttribute('style');
            return iframeSelector.setAttribute('scrolling', void 0);
          } else {
            iframeSelector.style.setProperty('max-width', data.width);
            iframeSelector.style.setProperty('width', '100%');
            iframeSelector.style.setProperty('height', data.height);
            iframeSelector.style.setProperty('max-height', data.maxHeight);
            if (data.backgroundColor != null) {
              iframeSelector.style.setProperty('background-color', data.backgroundColor);
            }
            if (data.transparentMode === 'true') {
              backgroundSelector.style.setProperty('background-color', 'transparent');
            }
            if (data.showCloseWindow === 'true') {
              closeSelector.style.setProperty('display', 'block');
            }
            // ie 9이하에서는 overflow 속성을 인식하지 못한다.
            iframeSelector.style.overflow = data.overflow;
            if (data.scrolling != null) {
              return iframeSelector.setAttribute('scrolling', data.scrolling);
            }
          }
          break;
        case 'BootpayError':
          try {
            if (_this3.methods.error != null) {
              _this3.methods.error.call(_this3, data);
            }
          } catch (error1) {
            e = error1;
            _this3.sendPaymentStepData({
              step: 'error',
              status: -1,
              msg: e
            });
            throw e;
          }
          _this3.sendPaymentStepData({
            step: 'error',
            status: 1
          });
          return _this3.removePaymentWindow();
        case 'BootpayDone':
          _this3.progressMessageHide();
          try {
            _this3.methods.done.call(_this3, data);
          } catch (error1) {
            e = error1;
            _this3.sendPaymentStepData({
              step: 'done',
              status: -1,
              e: e
            });
            throw e;
          }
          _this3.sendPaymentStepData({
            step: 'done',
            status: 1
          });
          return _this3.removePaymentWindow();
        case 'BootpayClose':
          _this3.progressMessageHide();
          return _this3.removePaymentWindow();
      }
    });
  },
  // 결제 실행 단계를 로그로 보낸다.
  sendPaymentStepData: function sendPaymentStepData(data) {
    var encryptData;
    if (this.tk == null || this.applicationId == null) {
      // Transaction key가 없다면 실행할 필요가 없다.
      return;
    }
    data.version = this.version;
    data.tk = this.tk;
    data.application_id = this.applicationId;
    if (data.e != null) {
      data.msg = function () {
        try {
          return data.e.message;
        } catch (error1) {
          return data.e;
        }
      }();
      data.trace = function () {
        try {
          return data.e.stack;
        } catch (error1) {
          return void 0;
        }
      }();
    }
    encryptData = _aes2.default.encrypt(JSON.stringify(data), this.getData('sk'));
    return request.post([this.analyticsUrl(), "event"].join('/')).set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8').send({
      data: encryptData.ciphertext.toString(_encBase2.default),
      session_key: encryptData.key.toString(_encBase2.default) + '##' + encryptData.iv.toString(_encBase2.default)
    }).then(function (res) {
      return _logger2.default.debug("BOOTPAY MESSAGE: 결제 이벤트 데이터 정보 전송");
    }).catch(function (err) {
      return _logger2.default.error('BOOTPAY MESSAGE: \uACB0\uC81C \uC774\uBCA4\uD2B8 \uB370\uC774\uD130 \uC815\uBCF4 \uC804\uC1A1\uC2E4\uD328 ' + JSON.stringify(err));
    });
  },
  forceClose: function forceClose() {
    if (this.methods.cancel != null) {
      this.methods.cancel.call(this, {
        action: 'BootpayCancel',
        message: '사용자에 의한 취소'
      });
    }
    return this.removePaymentWindow();
  },
  isLtBrowserVersion: function isLtBrowserVersion(version) {
    var idx, sAgent;
    sAgent = window.navigator.userAgent;
    idx = sAgent.indexOf("MSIE");
    if (!(idx > 0)) {
      return false;
    }
    return version > parseInt(sAgent.substring(idx + 5, sAgent.indexOf(".", idx)));
  },
  // IE 버전 blocking
  blockIEVersion: function blockIEVersion() {
    return this.isLtBrowserVersion(this.ieMinVersion);
  },
  // 결제창을 삭제한다.
  removePaymentWindow: function removePaymentWindow() {
    var callClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var e;
    document.body.style.removeProperty('bootpay-modal-open');
    if (document.getElementById(this.windowId) != null) {
      document.getElementById(this.windowId).outerHTML = '';
    }
    try {
      if (this.methods.close != null && callClose) {
        this.methods.close(this);
      }
    } catch (error1) {
      e = error1;
      this.sendPaymentStepData({
        step: 'close',
        status: -1,
        e: e
      });
      throw e;
    }
    this.sendPaymentStepData({
      step: 'close',
      status: 1
    });
    return this.tk = void 0;
  },
  // 결제할 iFrame 창을 만든다.
  iframeHtml: function iframeHtml(url) {
    return '<iframe id="' + this.iframeId + '" name="bootpay_inner_iframe" src="' + url + '" allowtransparency="true"></iframe>\n<div class="progress-message-window" id="progress-message">\n  <div class="progress-message spinner">\n    <div class="bounce1 bounce"></div><div class="bounce2 bounce"></div><div class="bounce3 bounce"></div>         &nbsp;\n    <span class="text" id="progress-message-text"></span>\n  </div>\n</div>\n<div class="progress-message-window over" id="close-button-window">\n  <div class="close-message-box">\n    <div class="close-popup">\n      <h4 class="sub-title">\uACB0\uC81C\uB97C \uC911\uB2E8\uD560\uAE4C\uC694?</h4>\n      <button class="close-payment-window" onclick="window.BootPay.forceClose();" type="button" id="__bootpay-close-button">\uB2EB\uAE30</button>\n    </div>\n  </div>\n</div>';
  },
  progressMessageHide: function progressMessageHide() {
    var pms;
    pms = document.getElementById('progress-message');
    pms.style.setProperty('display', 'none');
    document.getElementById('progress-message-text').innerText = '';
    try {
      return document.getElementById(this.iframeId).removeEventListener('load', this.progressMessageHide);
    } catch (error1) {}
  },
  progressMessageShow: function progressMessageShow(msg) {
    var pms;
    pms = document.getElementById('progress-message');
    pms.style.setProperty('display', 'block');
    return document.getElementById('progress-message-text').innerText = msg;
  },
  cancel: function cancel(method) {
    this.methods.cancel = method;
    return this;
  },
  confirm: function confirm(method) {
    this.methods.confirm = method;
    return this;
  },
  ready: function ready(method) {
    this.methods.ready = method;
    return this;
  },
  error: function error(method) {
    this.methods.error = method;
    return this;
  },
  done: function done(method) {
    this.methods.done = method;
    return this;
  },
  close: function close(method) {
    this.methods.close = method;
    return this;
  },
  transactionConfirm: function transactionConfirm(data) {
    var html;
    if (data == null || data.receipt_id == null) {
      alert('결제 승인을 하기 위해서는 receipt_id 값이 포함된 data값을 함께 보내야 합니다.');
      _logger2.default.error('this.transactionConfirm(data); 이렇게 confirm을 실행해주세요.');
      return;
    }
    html = '<input type="hidden" name="receipt_id" value="' + data.receipt_id + '" />\n<input type="hidden" name="application_id" value="' + this.applicationId + '" />';
    document.getElementById('bootpay_confirm_form').innerHTML = html;
    document.bootpay_confirm_form.target = 'bootpay_inner_iframe';
    document.bootpay_confirm_form.submit();
    return this;
  }
};

window.BootPay.initialize();

exports.default = window.BootPay;